import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ProfileEditComponent } from '../../users-management/components/profile-edit/profile-edit.component';
import { CommonModule } from '@angular/common';
import { ThemeLanguageSelectorComponent } from './theme-language-selector/theme-language-selector.component';
import { AuthStore } from '../../login/store/auth.store';
import { CloseButtonComponent } from '../../../../shared/ui/close-button/close-button.component';
import { SharedUIService } from '../../../../shared/services';
import { AppStore } from '../../../app.store';
import { TranslatePipe } from "../../../shared/pipes/translationPipe";

@Component({
  selector: 'app-user-profile',
  standalone: true,
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    ProfileEditComponent,
    ThemeLanguageSelectorComponent,
    CloseButtonComponent,
    TranslatePipe
],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileComponent {
  readonly authStore = inject(AuthStore);
  readonly appStore = inject(AppStore);
  readonly sharedUI = inject(SharedUIService);
}
